module.exports = __webpack_public_path__ + "img/changeImageIcon.d6252ac4.svg";